<template>
  <div>
    <el-row :gutter="10">
      <el-col :md="2" :lg="2" class="no-wrap">
        <el-button type="primary" size="medium" @click="addDialog=true">新建签到活动</el-button>
      </el-col>
      <!-- <el-col :md="3" :lg="4" class="no-wrap">
        <el-input placeholder="活动名称" v-model="searchParams.activityName"  size="medium" />
      </el-col>
      <el-col :md="3" :lg="4" class="no-wrap">
        <el-input placeholder="状态" v-model="searchParams.status" size="medium" >
          <el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button>
        </el-input>
      </el-col> -->
    </el-row>
    <el-table
    :data="tableData"
    style="width: 100%">
      <el-table-column
        fixed
        prop="id"
        label="序号"
        width="100">
      </el-table-column>
      <el-table-column
        prop="name"
        label="活动名称" width="auto">
      </el-table-column>
      <el-table-column
        prop="start_time"
        label="开始时间"
        width="auto">
      </el-table-column>
      <el-table-column
        prop="end_time"
        label="结束时间"
        width="auto">
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        width="auto">  
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间"
        width="auto">
      </el-table-column>
      <el-table-column
        label="操作"  
        width="auto">
        <template slot-scope="scope">
          <el-button @click="detailDialogShow(scope.row)" type="text" size="small">查看</el-button>
          <el-button type="text" size="small" @click="editDialogShow(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="total_count > searchParams.pagesize" class="content-padded content-center">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="searchParams.page"
        :total="total_count" :page-size="searchParams.pagesize">
      </el-pagination>
    </div>
    <!--------------------- 新建签到活动 ------------------------>
    <el-dialog title="新建签到活动" width="80%" :visible.sync="addDialog">
      <el-form :model="addData">
        <el-form-item label="活动名称">
          <el-col :span="10">
            <el-input v-model="addData.name" autocomplete="off" ></el-input>
          </el-col>
        </el-form-item>
        <!-- <el-form-item label="活动类型">
          <el-col :span="10">
            <el-select v-model="addData.act_type" placeholder="请选择">
                <el-option
                  v-for="item in actTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
        </el-col>
        </el-form-item> -->
        <!-- <el-form-item label="时间范围" v-show="addData.act_type==='f'">
          <el-col :span="10">
            <el-date-picker
              v-model="addData.start_time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-col>
        </el-form-item> -->
        <el-form-item label="启用状态">
          <el-col :span="10">
          <el-switch
            v-model="addData.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="1"
            inactive-value="2">
          </el-switch>
        </el-col>
        </el-form-item>
        <el-form-item label="每日签到积分" v-show="addData.act_type==='d'">
          <el-col :span="5">
            <el-input v-model="addData.points_num" @input="handleInt"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="每日签到图片：" v-show="addData.act_type==='d'" style="width: 30%; display: inline-block; margin: 20px">
          <div @click="handleImgPicker('daily_sign_img')" class="upload-box">
            <img v-if="addData.daily_sign_img" :src="addData.daily_sign_img" class="avatar"/>
            <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>            
          </div>
          <div class="frm-tips">
            注：图片|只能上传jpg/png文件，尺寸建议为1170*2260，单位为px，且不超过500KB
          </div>
        </el-form-item>
        <el-form-item label="连续签到奖励" v-show="addData.act_type==='d'"></el-form-item>
        <el-form-item v-for="(item, index) in addData.award" :key="item.key" v-show="addData.act_type==='d'">
          <el-col :span="1.5" style="color: blue;">类型：</el-col>
          <el-col :span="3">
            <el-select v-model="item.award_type" placeholder="请选择" size="small">
              <el-option
                v-for="opt in awardOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="1.5" style="color: blue;">连续天数：</el-col>
          <el-col :span="2">
            <el-input v-model="item.period_num" size="small"></el-input>
          </el-col>
          <el-col :span="1.5" style="color: blue;">奖励积分：</el-col>
          <el-col :span="4">
            <el-input v-model="item.award_content" size="small"></el-input>
          </el-col>
          <el-col :span="1.5" style="color: blue;">展示图片：</el-col>
          <el-col :span="2">
            <div @click="handleImgPicker('continuous_sign_img', index)" class="upload-box" style="width: 80px; height: 80px;">
              <img v-if="item.image" :src="item.image" class="avatar" style="width: 80px; height: 80px;"/>
              <i v-else class="iconfont icon-camera avatar-uploader-icon" style="font-size: 20px;"></i>            
            </div>
          </el-col>
          <el-col :span="1.5" style="color: blue;">描述：</el-col>
          <el-col :span="4">
            <el-input v-model="item.award_description" size="small" placeholder="请输入奖品描述"></el-input>
          </el-col>
          <el-col :span="2">
            <el-button @click.prevent="removeAward(item)" size="small" type="danger">删除</el-button>
          </el-col>
        </el-form-item>
        <el-button @click="addPeriod" type="text" size="small" v-show="addData.act_type==='d'">新增连续签到奖励</el-button>
        <!-- <el-button @click="addPeriod" type="text" size="small" >新增连续签到奖励</el-button> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="newActivity">确 定</el-button>
      </div>
    </el-dialog>
    <!--------------------- 编辑签到活动 ------------------------>
    <el-dialog title="编辑签到活动" width="80%" :visible.sync="editDialog">
      <el-form :model="editData">
        <el-form-item label="活动名称">
          <el-input v-model="editData.name" autocomplete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="活动类型">
          <el-col :span="10">
            <el-select v-model="editData.act_type" placeholder="请选择">
                <el-option
                  v-for="item in actTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
        </el-col>
        </el-form-item> -->
        <!-- <el-form-item label="时间范围" v-show="editData.act_type==='f'">
          <el-col :span="10">
            <el-date-picker
              v-model="editData.start_time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-col>
        </el-form-item> -->
        <el-form-item label="启用状态">
          <el-col :span="10">
          <el-switch
            v-model="editData.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value='1'
            inactive-value='2'>
          </el-switch>
        </el-col>
        </el-form-item>
        <el-form-item label="签到奖励积分数" v-show="editData.act_type==='d'">
          <el-col :span="5">
            <el-input v-model="editData.points_num" @input="handleInt"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="每日签到图片：" v-show="editData.act_type==='d'" style="width: 30%; display: inline-block; margin: 20px">
          <div @click="handleImgPicker('daily_sign_img')" class="upload-box">
            <img v-if="editData.daily_sign_img" :src="editData.daily_sign_img" class="avatar"/>
            <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>            
          </div>
          <div class="frm-tips">
            注：图片|只能上传jpg/png文件，尺寸建议为1170*2260，单位为px，且不超过500KB
          </div>
        </el-form-item>
        <el-form-item label="连续签到奖励" v-show="editData.act_type==='d'"></el-form-item>
        <el-form-item v-for="(item, index) in editData.award" :key="item.key" v-show="editData.act_type==='d'">
          <el-col :span="1.5" style="color: blue;">类型：</el-col> 
          <el-col :span="3">
            <el-select v-model="item.award_type" placeholder="请选择" size="small">
              <el-option
                v-for="opt in awardOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="1.5" style="color: blue;">连续天数：</el-col>
          <el-col :span="2">
            <el-input v-model="item.period_num" size="small"></el-input>
          </el-col>
          <el-col :span="1.5" style="color: blue;">奖励积分：</el-col> 
          <el-col :span="4">
            <el-input v-model="item.award_content" size="small"></el-input>
          </el-col>
          <el-col :span="1.5" style="color: blue;">展示图片：</el-col>
          <el-col :span="2">
            <div @click="handleImgPicker('continuous_sign_img', index)" class="upload-box" style="width: 80px; height: 80px;">
              <img v-if="item.image" :src="item.image" class="avatar" style="width: 80px; height: 80px;"/>
              <i v-else class="iconfont icon-camera avatar-uploader-icon" style="font-size: 20px;"></i>            
            </div>
          </el-col>
          <el-col :span="1.5" style="color: blue;">描述：</el-col>
          <el-col :span="3">
            <el-input v-model="item.award_description" size="small" placeholder="请输入奖品描述"></el-input>
          </el-col>
          <el-col :span="2">
            <el-button @click.prevent="removeEditAward(item)" size="small" type="danger">删除</el-button>
          </el-col>
        </el-form-item>
        <el-button @click="addEditPeriod" type="text" size="small" v-show="editData.act_type==='d'">新增连续签到奖励</el-button>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="editActivity">确 定</el-button>
      </div>
    </el-dialog>
    <!--------------------- 查看签到活动 ------------------------>
    <el-dialog title="查看签到活动" width="80%" :visible.sync="viewDialog">
      <el-form :model="detailData">
        <el-form-item label="活动名称">
          <el-input v-model="detailData.name" autocomplete="off" disabled="disabled"></el-input>
        </el-form-item>
        <!-- <el-form-item label="活动类型">
          <el-col :span="10">
            <el-select v-model="detailData.act_type" placeholder="请选择" disabled="disabled">
                <el-option
                  v-for="item in actTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
        </el-col>
        </el-form-item> -->
        <!-- <el-form-item label="时间范围" v-show="detailData.act_type==='f'">
          <el-col :span="10">
            <el-date-picker
              v-model="detailData.start_time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss" disabled="disabled">
            </el-date-picker>
          </el-col>
        </el-form-item> -->
        <el-form-item label="启用状态">
          <el-col :span="10">
          <el-switch
            v-model="detailData.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value='1'
            inactive-value='2' disabled="disabled">
          </el-switch>
        </el-col>
        </el-form-item>
        <el-form-item label="签到奖励积分数" v-show="detailData.act_type==='d'">
          <el-col :span="5">
            <el-input v-model="detailData.points_num" @input="handleInt" disabled="disabled"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="每日签到图片：" v-show="detailData.act_type==='d'" style="width: 30%; display: inline-block; margin: 20px">
          <div class="upload-box">
            <img v-if="detailData.daily_sign_img" :src="detailData.daily_sign_img" class="avatar"/>
            <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>            
          </div>
        </el-form-item>  
        <el-form-item label="连续签到奖励" v-show="detailData.act_type==='d'"></el-form-item>
        <el-form-item v-for="(item, index) in detailData.award" :key="item.key" v-show="detailData.act_type==='d'">
          <el-col :span="1.5" style="color: blue;">类型：</el-col> 
          <el-col :span="3">
            <el-select v-model="item.award_type" placeholder="请选择" disabled="disabled" size="small">
              <el-option
                v-for="opt in awardOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="1.5" style="color: blue;">连续天数：</el-col> 
          <el-col :span="2">
            <el-input v-model="item.period_num" disabled="disabled" size="small"></el-input>
          </el-col>
          <el-col :span="1.5" style="color: blue;">奖励积分：</el-col> 
          <el-col :span="4">
            <el-input v-model="item.award_content" disabled="disabled" size="small"></el-input>
          </el-col>
          <el-col :span="1.5" style="color: blue;">展示图片：</el-col>
          <el-col :span="3">
            <img v-if="item.image" :src="item.image" class="avatar" style="width: 80px; height: 80px;"/>
          </el-col>
          <el-col :span="1.5" style="color: blue;">描述：</el-col>
          <el-col :span="3">  
            <el-input v-model="item.award_description" disabled="disabled" size="small"></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="viewDialog = false">取 消</el-button>
      </div>
    </el-dialog>

    <imgPicker :dialog-visible="imgDialog" :sc-status="isGetImage" @chooseImg="pickImg" @closeImgDialog="closeImgDialog"></imgPicker>
  </div>
</template>

<script>
import store from '@/store'
import {mapGetters} from 'vuex'
import imgPicker from "@/components/imageselect"
import {
  getMembersSignActivitys,
  AddActivitys,
  EditActivitys
} from '../../../api/members_sign'
export default {
  components: {
    imgPicker
  },

  data() {
    return {
      tableData:[],
      total_count: 0,
      searchParams: {
        activityName: '',
        status:1,
        page: 1,
        pagesize: 10
      },
      params: {
        page: 1,
        pagesize: 10,
      },
      addDialog: false,
      editDialog: false,
      viewDialog:false,
      addData:{
        name:'',
        act_type:'d',
        award:[],
        points_num:'',
        start_time:'',
        end_time:'',
        status:1,
        daily_sign_img:''
      },
      editData:{
        id:'',
        name:'',
        act_type:'d',
        award:[],
        points_num:'',
        start_time:'',
        status:1,
        daily_sign_img:''
      },
      detailData:{
        name:'',
        act_type:'d',
        award:[],
        points_num:'',
        start_time:'',
        status:1,
        daily_sign_img:''
      },
      awardOptions: [
        // {
        //   value: 'coupon',
        //   label: '优惠券'
        // }, 
        {
          value: 'points',
          label: '积分'
        }
      ],
      actTypeOptions:[
      {
          value: 'f',
          label: '指定时间范围'
        }, {
          value: 'd',
          label: '默认'
        }
      ],
      imgDialog: false,
      isGetImage: false,
      pickerImgType: '',
      credential_url_index: 0
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },

  methods: {
    init(){ },
    getList(params){
      if(params==null){
        let params = this.searchParams
      }
      getMembersSignActivitys(params).then(res=>{
        if(res.status==200){
          console.log(res.data.data)
          res.data.data.list.forEach(function(currentValue, index, array){
            if(currentValue.status==1){
              currentValue.status = "启用"
            }else{
              currentValue.status = "禁用"
            }
          })
          this.tableData = res.data.data.list
          this.total_count = res.data.data.total_count
        }
      })
    },
    editDialogShow(row){
      this.editData = {
        id:row.id,
        name:row.name,
        act_type:row.act_type,
        award:row.award || [],
        points_num:row.points_num,
        start_time:row.start_time,
        status:row.status,
        daily_sign_img:row.daily_sign_img
      };
      console.log("!!!!!!!!!!!!!!!!!!!!!!")
      console.log(this.editData)
      console.log("!!!!!!!!!!!!!!!!!!!!!!")
      this.editDialog = true
      // 不再从award[0].award_content设置points_num，使用最外层的points_num
      // if(row.act_type=='d' && this.editData.award.length > 0){
      //   this.editData.points_num = this.editData.award[0].award_content
      // }
      if(row.act_type=='f'){
        this.editData.start_time = [row.start_time,row.end_time]
      }
      if(this.editData.status==="启用"){
        this.editData.status = '1'
      }else{
        this.editData.status = '2'
      }
      console.log(this.editData)
    },
    detailDialogShow(row){
      this.detailData = {
        name:row.name,
        act_type:row.act_type,
        award:row.award,
        points_num:row.points_num,
        start_time:row.start_time,
        status:row.status,
        daily_sign_img:row.daily_sign_img
      };
      this.viewDialog = true
      // 不再从award[0].award_content设置points_num，使用最外层的points_num
      // if(row.act_type=='d'){
      //   this.detailData.points_num = this.detailData.award[0].award_content
      // }else{
      //   this.detailData.award = row.award
      // }
      // 始终使用从后端获取的award数据
      this.detailData.award = row.award
      if(row.act_type=='f'){
        this.detailData.start_time = [row.start_time,row.end_time]
      }
      if(this.detailData.status==="启用"){
        this.detailData.status = '1'
      }else{
        this.detailData.status = '2'
      }
    },
    newActivity(){
      let addparam = {}
      if(this.addData.act_type=='d'){
        addparam.name = this.addData.name
        addparam.act_type = this.addData.act_type
        addparam.points_num = this.addData.points_num
        addparam.award = this.addData.award
        addparam.status = this.addData.status
        addparam.daily_sign_img = this.addData.daily_sign_img
      }else{
        addparam.name = this.addData.name
        addparam.act_type = this.addData.act_type
        addparam.award = this.addData.award
        addparam.status = this.addData.status
        addparam.start_time = this.addData.start_time[0]
        addparam.end_time = this.addData.start_time[1]
        addparam.daily_sign_img = this.addData.daily_sign_img
      }
      var timeSpan = this.diffDays(this.addData.start_time[0],this.addData.start_time[1])+1
      let isThanSet = false
      this.addData.award.forEach(function(currentValue, index, array){
        if(currentValue.period_num>timeSpan){
          isThanSet = true
        }
      })
      if(isThanSet==true){
        this.$message({
              showClose: true,
              message: '连续签到天数不能设置超过设定的时间天数',
              type: 'error'
        })
        return false;
      }
      AddActivitys(addparam).then(res=>{
        this.$message({
            showClose: true,
            message: "活动已创建！",
            type: 'success'
        })
        this.addData = {
          name:'',
          act_type:'d',
          award:[],
          points_num:'',
          start_time:'',
          end_time:'',
          status:1,
          daily_sign_img:''
        }
        this.addDialog = false
        this.getList()
      })
    },
    editActivity(){
      let editparam = {}
      if(this.editData.act_type=='d'){
        editparam.id = this.editData.id
        editparam.name = this.editData.name
        editparam.act_type = this.editData.act_type
        editparam.points_num = this.editData.points_num
        editparam.award = this.editData.award
        editparam.status = this.editData.status
        editparam.daily_sign_img = this.editData.daily_sign_img
      }else{
        editparam.id = this.editData.id
        editparam.name = this.editData.name
        editparam.act_type = this.editData.act_type
        editparam.award = this.editData.award
        editparam.status = this.editData.status
        editparam.start_time = this.editData.start_time[0]
        editparam.end_time = this.editData.start_time[1]
        editparam.daily_sign_img = this.editData.daily_sign_img
      }
      var timeSpan = this.diffDays(this.editData.start_time[0],this.editData.start_time[1])+1
      let isThanSet = false
      this.editData.award = Array.from(this.editData.award); 
      this.editData.award.forEach(function(currentValue, index, array){
        if(currentValue.period_num>timeSpan){
          isThanSet = true
        }
      })
      // console.log(this.editData.award)
      if(isThanSet==true){
        this.$message({
              showClose: true,
              message: '连续签到天数不能设置超过设定的时间天数',
              type: 'error'
        })
        return false;
      }
      // console.log(editparam)
      EditActivitys(editparam).then(res=>{
        this.$message({
            showClose: true,
            message: "活动已修改！",
            type: 'success'
        })
        this.editDialog = false
        this.getList()
      })
    },
    diffDays(date1, date2) {  
      var timeDiff = Math.abs(new Date(date1).getTime() - new Date(date2).getTime());  
      var seconds = timeDiff / 1000;  
      var minutes = seconds / 60;  
      var hours = minutes / 60;  
      var days = hours / 24;  
      return days;  
    },
    addPeriod() {
      if (this.addData.award.length >= 3) {
        this.$message({
          showClose: true,
          message: '奖品设置不能大于3个',
          type: 'warning'
        });
        return;
      }
      this.addData.award.push({
          period_num:'',
          award_type:'points',
          award_content:'',
          award_description:'',
          image:''
      });
      console.log(this.addData.award)
    },
    addEditPeriod() {
      if (this.editData.award.length >= 3) {
        this.$message({
          showClose: true,
          message: '奖品设置不能大于3个',   
          type: 'warning'
        });
        return;
      }
      this.editData.award.push({
          period_num:'',
          award_type:'points',
          award_content:'',
          award_description:'',
          image:''
      });
      console.log(this.editData.award)
    },
    removeAward(item) {
      var index = this.addData.award.indexOf(item)
      if (index !== -1) {
        this.addData.award.splice(index, 1)
      }
    },
    removeEditAward(item) {
      var index = this.editData.award.indexOf(item)
      if (index !== -1) {
        this.editData.award.splice(index, 1)
      }
    },
    handleCurrentChange(val) {
      this.searchParams.page = val
      this.getList(this.searchParams)
    },
    handleInt(value){
      this.addData.points_num = value.replace(/[^\d]/g,'');
    },
    handleImgPicker(pickerImgType, index = 0) {
      this.pickerImgType = pickerImgType;
      this.credential_url_index = index;
      this.imgDialog = true;
      this.isGetImage = true;
    },
    pickImg (data) {  
      if (this.pickerImgType == 'continuous_sign_img') {
          if (this.addDialog) {
              this.addData.award[this.credential_url_index]['image'] = data.url;
          } else if (this.editDialog) {
              this.editData.award[this.credential_url_index]['image'] = data.url;
          }
      } else {
          if (this.addDialog) {
              this.addData[this.pickerImgType] = data.url;
          } else if (this.editDialog) {
              this.editData[this.pickerImgType] = data.url;
          }
      }
      this.imgDialog = false;
    },
    closeImgDialog () {
        this.imgDialog = false
        this.isGetImage = false
    }
  },
  mounted() {
    let params = {
      page: 1,
      pagesize: 10
    }
    this.getList(params)
  }
}
</script>

<style>
.no-wrap{
  white-space: nowrap;  
}
.el-date-editor .el-range-separator{
  width:10%;
}
</style>


// WEBPACK FOOTER //
// list.vue?061c1e97